import {
  getLast12Months,
  getLast30Days,
  getLast365Days,
  getLast7Days,
  getLast90Days,
  getLastMonth,
  getLastYear,
  getToday,
  getYesterday,
} from '../helpers';
import type { IDateTimeFilterMapping } from '../types';

export enum MainDateTimePickerAlias {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  LAST_7_DAYS = 'last7days',
  LAST_30_DAYS = 'last30days',
  LAST_90_DAYS = 'last90days',
  LAST_365_DAYS = 'last365days',
  LAST_MONTH = 'lastMonth',
  LAST_12_MONTHS = 'last12Months',
  LAST_YEAR = 'lastYear',
}

export function getDateTimeFilterMapping(): Record<
  MainDateTimePickerAlias,
  IDateTimeFilterMapping
> {
  const mappings: Record<MainDateTimePickerAlias, IDateTimeFilterMapping> = {
    [MainDateTimePickerAlias.TODAY]: {
      title: 'Today',
      alias: MainDateTimePickerAlias.TODAY,
      getDateRange: getToday,
    },
    [MainDateTimePickerAlias.YESTERDAY]: {
      title: 'Yesterday',
      alias: MainDateTimePickerAlias.YESTERDAY,
      getDateRange: getYesterday,
    },

    [MainDateTimePickerAlias.LAST_7_DAYS]: {
      title: 'Last 7 days',
      alias: MainDateTimePickerAlias.LAST_7_DAYS,
      getDateRange: getLast7Days,
    },

    [MainDateTimePickerAlias.LAST_30_DAYS]: {
      title: 'Last 30 days',
      alias: MainDateTimePickerAlias.LAST_30_DAYS,
      getDateRange: getLast30Days,
    },

    [MainDateTimePickerAlias.LAST_90_DAYS]: {
      title: 'Last 90 days',
      alias: MainDateTimePickerAlias.LAST_90_DAYS,
      getDateRange: getLast90Days,
    },

    [MainDateTimePickerAlias.LAST_365_DAYS]: {
      title: 'Last 365 days',
      alias: MainDateTimePickerAlias.LAST_365_DAYS,
      getDateRange: getLast365Days,
    },

    [MainDateTimePickerAlias.LAST_MONTH]: {
      title: 'Last month',
      alias: MainDateTimePickerAlias.LAST_MONTH,
      getDateRange: getLastMonth,
    },

    [MainDateTimePickerAlias.LAST_12_MONTHS]: {
      title: 'Last 12 months',
      alias: MainDateTimePickerAlias.LAST_12_MONTHS,
      getDateRange: getLast12Months,
    },

    [MainDateTimePickerAlias.LAST_YEAR]: {
      title: 'Last year',
      alias: MainDateTimePickerAlias.LAST_YEAR,
      getDateRange: getLastYear,
    },
  };

  return mappings;
}

export function getDateTimeFilterByAlias(alias: MainDateTimePickerAlias): IDateTimeFilterMapping {
  const mappings = getDateTimeFilterMapping();
  return mappings[alias];
}
